import { render, staticRenderFns } from "./TranslateView.vue?vue&type=template&id=3d364e33"
import script from "./TranslateView.vue?vue&type=script&lang=ts"
export * from "./TranslateView.vue?vue&type=script&lang=ts"
import style0 from "./TranslateView.vue?vue&type=style&index=0&id=3d364e33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports